import {
  ComponentRef,
  WixComponentManifestStyle,
} from '@wix/editor-platform-sdk-types'
import {getAPI} from '../privates/editorAPI'

export default function (appData) {
  /**
   * @doc Editor
   * @note `Classic` `Studio`
   * @example
   * await editorSDK.editor.manifest.get.styleDefinition(token, {
   *   compRef: {
   *     id: 'some-id',
   *     type: 'DESKTOP',
   *   },
   *   innerElementPath: [],
   * });
   * @param token - panel token
   * @param options -
   * - compRef: ComponentRef
   * - innerElementPath: string[]
   * @description Gets the style definition from Builder component manifest
   * @returns A promise with object of design variables from Builder manifest structure or null if there are no styles
   */
  function getStyleDefinitionFromManifest(
    token: string,
    options: {compRef: ComponentRef; innerElementPath?: string[]},
  ): Promise<WixComponentManifestStyle | null> {
    return getAPI().then((api) => {
      return api.editor.getStyleDefinitionFromManifest(appData, token, options)
    })
  }
  return {
    get: {
      styleDefinition: getStyleDefinitionFromManifest,
    },
  }
}
